/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Detail_HeadlineInputs */

const en_subscription_detail_headline = /** @type {(inputs: Subscription_Detail_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription Plan Details`)
};

const ar_subscription_detail_headline = /** @type {(inputs: Subscription_Detail_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تفاصيل خطة الاشتراك`)
};

const de_subscription_detail_headline = /** @type {(inputs: Subscription_Detail_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details zum Abonnementplan`)
};

const es_subscription_detail_headline = /** @type {(inputs: Subscription_Detail_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles del plan de suscripción`)
};

const fr_subscription_detail_headline = /** @type {(inputs: Subscription_Detail_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détails du plan d’abonnement`)
};

const it_subscription_detail_headline = /** @type {(inputs: Subscription_Detail_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dettagli del piano di abbonamento`)
};

const ja_subscription_detail_headline = /** @type {(inputs: Subscription_Detail_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプションプランの詳細`)
};

const ko_subscription_detail_headline = /** @type {(inputs: Subscription_Detail_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독 플랜 세부 정보`)
};

const pt_br_subscription_detail_headline = /** @type {(inputs: Subscription_Detail_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhes do Plano de Assinatura`)
};

const ru_subscription_detail_headline = /** @type {(inputs: Subscription_Detail_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Детали плана подписки`)
};

const th_subscription_detail_headline = /** @type {(inputs: Subscription_Detail_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายละเอียดแผนการสมัครสมาชิก`)
};

const tr_subscription_detail_headline = /** @type {(inputs: Subscription_Detail_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelik Planının Detayları`)
};

const zh_cn_subscription_detail_headline = /** @type {(inputs: Subscription_Detail_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 会员权益说明`)
};

const zh_tw_subscription_detail_headline = /** @type {(inputs: Subscription_Detail_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`訂閱方案詳細說明`)
};

/**
* | output |
* | --- |
* | "Subscription Plan Details" |
*
* @param {Subscription_Detail_HeadlineInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_detail_headline = /** @type {((inputs?: Subscription_Detail_HeadlineInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Detail_HeadlineInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_detail_headline(inputs)
	if (locale === "ar") return ar_subscription_detail_headline(inputs)
	if (locale === "de") return de_subscription_detail_headline(inputs)
	if (locale === "es") return es_subscription_detail_headline(inputs)
	if (locale === "fr") return fr_subscription_detail_headline(inputs)
	if (locale === "it") return it_subscription_detail_headline(inputs)
	if (locale === "ja") return ja_subscription_detail_headline(inputs)
	if (locale === "ko") return ko_subscription_detail_headline(inputs)
	if (locale === "pt_br") return pt_br_subscription_detail_headline(inputs)
	if (locale === "ru") return ru_subscription_detail_headline(inputs)
	if (locale === "th") return th_subscription_detail_headline(inputs)
	if (locale === "tr") return tr_subscription_detail_headline(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_detail_headline(inputs)
	return zh_tw_subscription_detail_headline(inputs)
});